import type { CondensatePhaseVolumeFactorCalculator } from "../../d";

import { condensatePhaseVolumeFactorBoCalculator } from "./condensatePhaseVolumeFactorBoCalculator";
import { dewPointPressurePSIACalculator } from "./dewPointPressurePSIACalculator";
import { solutionGasRsoCalculator } from "./solutionGasRsoCalculator";

export const condensatePhaseVolumeFactorCalculator: CondensatePhaseVolumeFactorCalculator =
  {
    solutionGasRsoCalculator,
    dewPointPressurePSIACalculator,
    condensatePhaseVolumeFactorBoCalculator
  };
